<template>
    <div class="page-table mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            Opsiyon İşlemleri
        </div>
        <el-row :gutter="10">
            <el-col :lg="18" :md="18" :sm="24" :xs="24">
                <div class="page-header card-base card-shadow--medium animated fadeInUp">
                    <el-table
                            border
                            stripe
                            :data="opsiyonList"
                            style="width: 100%">
                        <el-table-column
                                label="Sıra"
                                type="index"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="baslik"
                                label="Opsiyon"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                label="İşlem"
                                align="right"
                                width="auto">
                            <template slot-scope="scope">
                                <el-tooltip content='Düzenle'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row); "
                                            type="text"
                                            class="buttonEdit"
                                            icon="el-icon-edit">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip content='Sil'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="dialogVisible = true; selection=scope.row; selectionIndex=scope.$index"
                                            type="text"
                                            class="buttonDel"
                                            icon="mdi mdi-delete mdi-24px">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
            <el-col :lg="6" :md="6" :sm="24" :xs="24">
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                    <el-form status-icon :model="opsiyonForm" :rules="rulesOpsiyon" ref="opsiyonForm"
                             @submit.native.prevent="enter"
                             class="demo-ruleForm">
                        <div>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Opsiyon Adı'
                                                  prop="baslik">:
                                        <el-input
                                                v-model="opsiyonForm.baslik"
                                                placeholder='Opsiyon Adı Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Opsiyon Adı (İngilizce)'
                                                  prop="baslikEN">:
                                        <el-input
                                                v-model="opsiyonForm.baslikEN"
                                                placeholder='Opsiyon Adı Giriniz'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Kategori' prop="secilenKategoriler">:
                                        <el-select
                                                multiple
                                                v-model="secilenKategoriler"
                                                style="width: 100%">
                                            <el-option v-for="item in kategoriList"
                                                       :key="item.ukategoriKodu"
                                                       :label="item.kategoriAdi"
                                                       :value="item.ukategoriKodu"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Opsiyon' prop="cevapTipi">:
                                        <el-select
                                                v-model="opsiyonForm.cevapTipi"
                                                style="width: 100%">
                                            <el-option value="1" label="Evet/Hayır(Switch)">Evet/Hayır(Switch)
                                            </el-option>
                                            <el-option value="2" label="Metin(Text)">Metin(Text)</el-option>
                                            <el-option value="3" label="Çok Seçenek(Selectbox)">Çok Seçenek(Selectbox)
                                            </el-option>
                                            <el-option value="4" label="Çok Seçenek(Checkbox)">Çok Seçenek(Checkbox)
                                            </el-option>
                                            <el-option value="5" label="Tek Seçenek(Radiobox)">Tek Seçenek(Radiobox)
                                            </el-option>
                                            <el-option value="6" label="Tarih(Date)">Tarih(Date)</el-option>
                                            <el-option value="7" label="Tarih-Saat(Date-Time)">Tarih-Saat(Date-Time)
                                            </el-option>
                                            <el-option value="8" label="Metin(Textarea)">Metin(Textarea)</el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <el-row class="col-p">
                            <el-form-item>
                                <el-button v-if="btnVisible" size="small" v-on:click="opsiyonTanimla('opsiyonForm')"
                                           type="primary">
                                    Tanımla
                                </el-button>
                                <el-button v-else size="small" v-on:click="guncelleme('opsiyonForm')" type="primary">
                                    Güncelle
                                </el-button>
                                <el-button v-if="!btnVisible" size="small" v-on:click="vazgec('opsiyonForm')">
                                    Vazgeç
                                </el-button>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="dialogVisible"
                width="30%"
                center>
            <span>"{{selection["baslik"]}}" opsiyonunu silmek istediğinize emin misiniz?</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="sil(selection,selectionIndex,opsiyonList), dialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="dialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import urunService from '../../../../WSProvider/UrunService'
    import notification from '../../../../notification'
    import JQuery from 'jquery';

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataEstasMil = "";
    export default {
        name: "OpsiyonIslemleri",
        mounted() {
            this.getOpsiyonListesi();
            this.getKategoriListesi();
        },
        data() {
            return {
                selectIcon: '1',
                radio: '1',
                opsiyonList: [],
                kategoriList: [],
                updateKodu: '',
                btnVisible: true,
                selection: '',
                selectionIndex: '',
                dialogVisible: false,
                duzenleBtnVisible: true,
                VisibleA: false,
                linkVisible: false,
                linkChange: true,
                disabled: false,
                secilenKategoriler: [],
                opsiyonForm: {
                    baslik: '',
                    baslikEN: '',
                    cevapTipi: '1',
                },
                rulesOpsiyon: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Opsiyon Giriniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            getOpsiyonListesi() {
                let self = this;
                urunService.opsiyonList().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                           if(e.durum === '1'){
                               self.opsiyonList.push(e);
                           }
                        });
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            getKategoriListesi() {
                urunService.kategoriList().then((response) => {
                    if (response.status === 200) {
                        if (response.data.length > 0) {
                            this.secilenKategoriler.push(response.data[0].ukategoriKodu);
                        }
                        this.kategoriList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            updateStart(scope) {
                urunService.opsiyonDetay(scope.uopsiyonKodu).then((response) => {
                    if (response.status === 200) {
                        this.opsiyonForm.baslik = response.data.baslik;
                        if(response.data.dil.en){
                            this.opsiyonForm.baslikEN = response.data.dil.en.baslik;
                        }else  this.opsiyonForm.baslikEN = "";
                        this.opsiyonForm.cevapTipi = response.data.cevapTipi;
                        this.updateKodu = response.data.uopsiyonKodu;
                        this.btnVisible = false;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            vazgec(formName) {
                this.$refs[formName].resetFields();
                this.btnVisible = true;
            },
            enter() {
                if (this.btnVisible) {
                    this.opsiyonTanimla('opsiyonForm');
                } else this.guncelleme('opsiyonForm')
            },
            opsiyonTanimla(formName) {
                var dil = [];

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        dil = {
                            en: this.opsiyonForm.baslikEN
                        };
                        urunService.urunOpsiyonTanimlama(this.opsiyonForm.baslik, this.opsiyonForm.cevapTipi, '1', this.secilenKategoriler,dil).then((response) => {
                            if (response.status === 200) {
                                this.opsiyonList.push(response.data);
                                notification.Status('success', this, 'Opsiyon başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir model zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            guncelleme(formName) {
                var dil = [];

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        dil = {
                            en: this.opsiyonForm.baslikEN
                        };
                        urunService.opsiyonGuncelle(this.updateKodu, this.opsiyonForm.baslik, this.opsiyonForm.cevapTipi,dil).then((response) => {
                            if (response.status === 200) {
                                this.opsiyonList.splice(this.selectionIndex, 1);
                                this.opsiyonList.splice(this.selectionIndex, 0, {
                                    baslik: response.data.baslik,
                                    baslikEN: response.data.dil.en.baslik ? response.data.dil.en.baslik : " ",
                                    cevapTipi: response.data.cevapTipi,
                                    uopsiyonKodu: response.data.uopsiyonKodu
                                });
                                notification.Status('success', this, 'Opsiyon başarıyla güncellendi...');
                                this.$refs[formName].resetFields();
                                this.btnVisible = true;
                            } else if (response.status === 200) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir model zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            sil(selection, index, list) {
                urunService.opsiyonKaldir(selection.uopsiyonKodu).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Opsiyon başarıyla silindi.');
                        list.splice(index, 1);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }

</script>


<style scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

</style>